import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useUser from "../../../hooks/useUser";

const BasicMenu = () => {
  const navigate = useNavigate();
  const [a, b, c, d, e, f, g, monitorUser, setMonitorUser, setDataMonitorLocalStorage, initialMonitorUser] = useUser();
  const isAdmin = monitorUser.role === 'admin';
  return (
    <Dropdown>
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        <FiMenu />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#/generalMonitor">Monitor Ventas</Dropdown.Item>
        <Dropdown.Item href="#/customersMonitor">
          Monitor Clientes
        </Dropdown.Item>
        {isAdmin && <Dropdown.Item href="#/adminMonitor">Admin Monitor</Dropdown.Item>}
        
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default BasicMenu;
